import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { Spacing8 } from 'autogen/design-tokens/tokens';
import Icon from 'components/Icon';
import { HeaderButton, type HeaderButtonProps } from 'components/quickView/shared/style';

const BackButton = styled(HeaderButton)`
    display: flex;
    gap: ${Spacing8};
    align-items: center;
`;

const DefaltBackButton = (props: PropsWithChildren<HeaderButtonProps>) => {
    const { children, ...restProps } = props;
    return (
        <BackButton {...restProps}>
            <Icon type="ChevronLeft" size={16} /> {children}
        </BackButton>
    );
};

export default DefaltBackButton;
